import { createTheme, styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import "../BaseCss";
import { myColor, myFontFamily } from "../BaseCss";
import {
  Box,
  CircularProgress,
  IconButton,
  Input,
  List,
  Select,
  StepConnector,
  stepConnectorClasses,
  Switch,
  Tab,
  Tabs,
  TextField,
  ThemeProvider,
} from "@mui/material";
import { DataGridPro, GridOverlay } from "@mui/x-data-grid-pro";
import { LicenseInfo } from "@mui/x-license";

import {
  PlayCircleFilled,
  Upcoming,
  LaptopChromebook,
  DriveFileRenameOutline,
  RocketLaunch,
  DescriptionTwoTone,
  SecurityTwoTone,
  LibraryAddCheckTwoTone,
  DocumentScanner,
  TextIncrease,
} from "@mui/icons-material";
import WifiOn from "../assets/images/wifi-on.svg";
import WifiOff from "../assets/images/wifi-off.svg";
import PropTypes from "prop-types";
import { Clear, Search } from "@mui/icons-material";

import AgentsIcon from "../assets/images/lpt-icon-white.svg";
import PackageIcon from "../assets/images/package-icon-white.svg";
import DateIcon from "../assets/images/date-time-icon-white.svg";
import AccountIcon from "../assets/images/users-icon-white.svg";
import LaunchIcon from "../assets/images/launch-icon-white.svg";
import ArrowBackIcon from "../assets/images/arrow-bottom.svg";
import { env } from "../env";

LicenseInfo.setLicenseKey(env.REACT_APP_DATAGRIDPRO_KEY);

export const colorTheme = {
  backgroundColor: "#242933",
};

export const pageTheme = createTheme({
  palette: {
    mode: "dark",
  },
  typography: {
    pageTitle: {
      fontSize: "22px",
      color: "#fff",
      fontWeight: "600",
      marginBottom: 0,
      fontFamily: myFontFamily.PrimaryFont,
      letterSpacing: "1px",
      textShadow: "1px 1px #000",
    },
    subTitleContent: {
      fontSize: "1vw",
      color: "#fff",
      fontWeight: "400",
      fontFamily: myFontFamily.PrimaryFont,
      letterSpacing: "1px",
      textShadow: "1px 1px #000",
    },
    tableTitle: {
      fontWeight: "600",
      lineHeight: "30px",
      color: myColor.PrimaryFont,
      fontFamily: myFontFamily.PrimaryFont,
    },
    footTable: {
      fontSize: "14px",
      color: myColor.PrimaryFont,
      fontFamily: myFontFamily.PrimaryFont,
      marginLeft: "7px",
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: `
        h6 {
          font-size: 22px;
        }
      `,
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          backgroundColor: colorTheme.backgroundColor,
          borderRadius: "12px",
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          fontSize: "14px",
          borderBottom: "1px solid #242933",
          color: "#fff",
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          color: "white",
        },
        outlined: {
          marginLeft: "8px",
          backgroundColor: "#e328af",
          boxShadow: "0px 4px 4px rgb(0 0 0 / 4%)",
          borderRadius: "12px",
          fontWeight: "600",
          fontSize: "16px",
          textAlign: "center",
          color: "#ffffff",
          outline: "none",
          display: "inline-block",
          padding: "10px 30px 12px 30px",
          border: "1px solid #e328af",
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          backgroundColor: "#242933 !important",
          border: "1px solid gray",
          borderRadius: "8px",
          height: "38px",
          fontSize: "12px",
          color: "white",
          width: "100%",
          minWidth: "100px",
          padding: "3px 15px",
          marginTop: "10px",
        },
      },
    },
    MuiContainer: {
      styleOverrides: {
        root: {
          padding: "15px",
          backgroundColor: "#15132b",
          border: "1px solid #1e1c3a",
          boxShadow: "0px 4px 4px rgb(0 0 0 / 4%)",
          borderRadius: "12px",
          marginTop: "24px",
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        root: {
          color: myColor.PrimaryFont,
          backgroundColor: "#242933",
          borderColor: "rgb(30, 28, 58)",
          padding: ".375rem .75rem",
          borderRadius: ".25rem",
        },
        select: {
          color: myColor.PrimaryFont,
          backgroundColor: "#242933",
          borderColor: "rgb(30, 28, 58)",
          padding: ".375rem .75rem",
          borderRadius: ".25rem",
        },
      },
    },
    MuiStepIcon: {
      styleOverrides: {
        root: {
          color: myColor.Icon,
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundColor: myColor.BgSecundary,
        },
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          color: "white",
        },
      },
    },
  },
});

export function CustomLoadingOverlay() {
  return (
    <GridOverlay style={{ backgroundColor: "#242933", opacity: 0.3 }}>
      <div>
        <CircularProgress color="secondary" />
      </div>
    </GridOverlay>
  );
}

export const MaterialUISwitch = styled(Switch)(({ theme }) => ({
  width: 62,
  height: 34,
  padding: 7,
  "& .MuiSwitch-switchBase": {
    margin: 1,
    padding: 0,
    transform: "translateX(6px)",
    "&.Mui-checked": {
      color: "#fff",
      transform: "translateX(22px)",

      "& .MuiSwitch-thumb:before": {
        backgroundImage: `url('${WifiOff}')`,
      },
      "& + .MuiSwitch-track": {
        opacity: 1,
        backgroundColor: "rgba(255, 71, 71, 0.2)",
      },
    },
  },
  "& .MuiSwitch-thumb": {
    backgroundColor: "rgb(13, 11, 33)",
    width: 32,
    height: 32,
    "&:before": {
      content: "''",
      position: "absolute",
      width: "80%",
      height: "80%",
      left: "10%",
      top: "10%",
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center",
      backgroundImage: `url('${WifiOn}')`,
    },
  },
  "& .MuiSwitch-track": {
    opacity: 1,
    backgroundColor: "rgb(24, 40, 48)",
    borderRadius: 20 / 2,
  },
}));
export const PrimaryButton = styled(Button)({
  margin: "8px",
  boxShadow: "none",
  textTransform: "none",
  fontSize: 16,
  padding: "10px 30px",
  borderRadius: "12px",
  border: "1px solid",
  lineHeight: 1.5,
  backgroundColor: myColor.PrimaryButton,
  color: myColor.PrimaryFont,
  borderColor: myColor.PrimaryButton,
  fontFamily: [
    "-apple-system",
    "BlinkMacSystemFont",
    '"Segoe UI"',
    "Roboto",
    '"Helvetica Neue"',
    "Arial",
    "sans-serif",
    '"Apple Color Emoji"',
    '"Segoe UI Emoji"',
    '"Segoe UI Symbol"',
  ].join(","),
  "&:hover": {
    backgroundColor: myColor.PrimaryButton,
    borderColor: myColor.PrimaryFont,
    boxShadow: "none",
  },
  "&:active": {
    boxShadow: "none",
    backgroundColor: myColor.PrimaryButton,
    borderColor: myColor.PrimaryButton,
  },
  "&:focus": {
    boxShadow: myColor.PrimaryFont,
  },
  "&:disabled": {
    border: "none",
  },
});
export const SecondaryButton = styled(Button)({
  margin: "8px",
  boxShadow: "none",
  textTransform: "none",
  fontSize: 16,
  padding: "10px 30px",
  borderRadius: "12px",
  border: "1px solid gray",
  lineHeight: 1.5,
  backgroundColor: myColor.SecondaryButton,
  color: "#fff",
  // borderColor: "#090f1a",
  fontFamily: [
    "-apple-system",
    "BlinkMacSystemFont",
    '"Segoe UI"',
    "Roboto",
    '"Helvetica Neue"',
    "Arial",
    "sans-serif",
    '"Apple Color Emoji"',
    '"Segoe UI Emoji"',
    '"Segoe UI Symbol"',
  ].join(","),
  "&:hover": {
    backgroundColor: "#544628",
    borderColor: "#1C1A33",
    boxShadow: "none",
  },
  "&:active": {
    backgroundColor: "090f1a",
    borderColor: "#1C1A33",
    boxShadow: "none",
  },
  "&:focus": {
    boxShadow: "#1C1A33",
  },
});
export const ActionButton = styled(Button)({
  margin: "8px",
  boxShadow: "none",
  textTransform: "none",
  fontSize: 16,
  padding: "10px 30px",
  borderRadius: "12px",
  lineHeight: 1.5,
  backgroundColor: myColor.PrimaryButton,
  color: "#090f1a",
  fontFamily: [
    "-apple-system",
    "BlinkMacSystemFont",
    '"Segoe UI"',
    "Roboto",
    '"Helvetica Neue"',
    "Arial",
    "sans-serif",
    '"Apple Color Emoji"',
    '"Segoe UI Emoji"',
    '"Segoe UI Symbol"',
  ].join(","),
  "&:hover": {
    backgroundColor: myColor.gold,
    borderColor: myColor.goldsecondary,
    boxShadow: "none",
  },
  "&:active": {
    backgroundColor: "#621cb8",
    borderColor: "#1C1A33",
    boxShadow: "none",
  },
  "&:focus": {
    boxShadow: myColor.VeryDark,
  },
});

export const ArrowButton = styled(Button)({
  color: myColor.PrimaryFont,
  backgroundColor: myColor.BgSecundary,
  float: "right",
  marginTop: "12px",
  height: "38px",
  borderRadius: "15px",
  "&:hover": {
    backgroundColor: myColor.Icon,
    borderColor: myColor.Icon,
  },
});
export const ButtonActions = styled(Button)(({ theme }) => ({
  color: theme.palette.getContrastText("#544628"),
  backgroundColor: "#2e343d",
  border: "1px solid gray",
  "&:hover": {
    backgroundColor: "#544628",
  },
}));
export const SelectCustom = styled(Select)({
  border: "1px solid #fff",
  borderRadius: "8px",
  height: "45px",
  fontWeight: "600",
  fontSize: "13px",
  lineHeight: "22px",
  textAlign: "center",
  minWidth: "120px",
  maxWidth: "120px",
  wordBreak: "break-all",
  padding: "10px",
  color: "#ffab2d",
  textTransform: "capitalize",
});
export const InputSerch = styled(Input)({
  backgroundColor: "#15132b",
  border: "1px solid #1e1c3a",
  borderRadius: "8px",
  height: "38px",
  fontSize: "12px",
  width: "100%",
  minWidth: "200px",
  maxWidth: "200px",
  padding: "3px 15px",
  color: "#8e97ad",
  display: "block",
});
export const FormInputTextField = styled(TextField)(({ theme }) => ({
  color: "rgba(255,255,255,0.65)",
  "& .MuiInputLabel-root": {
    color: "rgba(255,255,255,0.65)",
  },
  "& .MuiOutlinedInput-root": {
    color: "rgba(255,255,255,0.65)",
    "& fieldset": {
      borderColor: "#464366",
    },
    "&:hover fieldset": {
      borderColor: "#fff",
    },

    "& .MuiSvgIcon-root": {
      color: "rgba(255,255,255,0.65) !important",
    },
  },
}));
export const FormInputText = styled(TextField)(({ theme }) => ({
  color: "transparent",
  borderColor: "transparent",
  "& .MuiInputLabel-root": {
    color: "transparent",
  },
  "& .MuiOutlinedInput-root": {
    color: "white",
    borderColor: "transparent",
    "& fieldset": {
      borderColor: "transparent",
    },
    "&:hover fieldset": {
      borderColor: "transparent",
    },

    "& .MuiSvgIcon-root": {
      color: "#fff !important",
    },
  },
}));

export const ListItemsExecution = styled(List)({
  textAlign: "center !important",
  "& .Mui-selected": {
    backgroundColor: "#c59d48 !important",
  },
  "& .Mui-selected:hover": {
    backgroundColor: "#544628",
  },
  "& .Mui-selected:focus": {
    backgroundColor: "#c59d48",
  },
  "& .MuiListItemButton-root": {
    backgroundColor: "#0a0818",
    padding: "10px",
    borderRadius: "10px",
    margin: "50px",
    textAlign: "center",
    fontSize: "100px",
  },
  "& .MuiListItemButton-root:hover": {
    backgroundColor: "#544628",
  },
  "& .MuiListItemButton-root:focus": {
    backgroundColor: "#c59d48",
  },
});
export const PageButton = styled(Button)({
  color: myColor.PrimaryFont,
  borderRadius: "15px",
  height: "38px",
  backgroundColor: myColor.Icon,
  float: "right",
  marginTop: "12px",
});

export const StyledDataGrid = styled(DataGridPro)(({ theme }) => ({
  border: 0,
  color: "rgba(255,255,255,0.85)",
  fontFamily: [
    "-apple-system",
    "BlinkMacSystemFont",
    '"Segoe UI"',
    "Roboto",
    '"Helvetica Neue"',
    "Arial",
    "sans-serif",
    '"Apple Color Emoji"',
    '"Segoe UI Emoji"',
    '"Segoe UI Symbol"',
  ].join(","),
  WebkitFontSmoothing: "auto",
  letterSpacing: "normal",
  "& .MuiDataGrid-columnsContainer": {
    backgroundColor: "#fff",
  },

  "& .MuiDataGrid-columnHeader": {
    backgroundColor: "#0d0b21",
  },
  "& .MuiDataGrid-columnHeader, .MuiDataGrid-cell": {
    borderBottom: "1px solid #1e1c3a",
  },
  "& .MuiDataGrid-columnsContainer, .MuiDataGrid-cell": {
    borderBottom: "1px solid #1e1c3a",
  },
  "& .MuiDataGrid-cell": {
    color: "rgba(255,255,255,0.65)",
    borderBottom: "1px solid #6a6886",
  },
  "& .MuiPaginationItem-root": {
    borderRadius: 0,
    color: "#fff",
  },
  "& .MuiTablePagination-displayedRows, .MuiTablePagination-selectLabel": {
    color: "#ffF",
  },
  ...customCheckbox(theme),
}));

function customCheckbox(theme) {
  return {
    "& .MuiCheckbox-root svg": {
      width: 16,
      height: 16,
      backgroundColor: "transparent",
      border: `2px solid #c59d48`,
      borderRadius: 2,
    },
    "& .MuiCheckbox-root svg path": {
      display: "none",
    },
    "& .MuiCheckbox-root.Mui-checked:not(.MuiCheckbox-indeterminate) svg": {
      backgroundColor: "#c59d48",
      borderColor: "#c59d48",
    },
    "& .MuiCheckbox-root.Mui-checked .MuiIconButton-label:after": {
      position: "absolute",
      display: "table",
      border: "2px solid #fff",
      borderTop: 0,
      borderLeft: 0,
      transform: "rotate(45deg) translate(-50%,-50%)",
      opacity: 1,
      transition: "all .2s cubic-bezier(.12,.4,.29,1.46) .1s",
      content: '""',
      top: "50%",
      left: "39%",
      width: 5.71428571,
      height: 9.14285714,
    },
    "& .MuiCheckbox-root.MuiCheckbox-indeterminate .MuiIconButton-label:after":
      {
        width: 8,
        height: 8,
        backgroundColor: "#c59d48",
        transform: "none",
        top: "39%",
        border: 0,
      },
  };
}

export function artifactBigIcon(fillColor) {
  fillColor = fillColor ? fillColor : "#ff5830";
  return (
    <svg
      height="100"
      viewBox="0 0 60 60"
      width="100"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Page-1" fill="none" fillRule="evenodd">
        <g id="063---virus-alert" fill={fillColor} fillRule="nonzero">
          <path
            id="Shape"
            d="m55 0h-50c-2.76005315.00330612-4.99669388 2.23994685-5 5v40c.00330612 2.7600532 2.23994685 4.9966939 5 5h15.24l-1.909 1.591c-1.5051472 1.2648646-1.872953 3.4336069-.869 5.124l1.681 2.8c.1806127.3132279.516242.5045637.8777878.5004101.3615459-.0041537.6926908-.2031497.8660598-.5204443.1733689-.3172946.1619565-.7034632-.0298476-1.0099658l-1.681-2.8c-.5013245-.8428848-.3175253-1.9249281.434-2.555l2.79-2.33c1.6421696 2.6142884 4.5127318 4.2010472 7.6 4.2010472s5.9578304-1.5867588 7.6-4.2010472l2.793 2.328c.7513881.6307395.9343659 1.7133585.432 2.556l-1.68 2.8c-.1918041.3065026-.2032165.6926712-.0298476 1.0099658.173369.3172946.5045139.5162906.8660598.5204443.3615458.0041536.6971751-.1871822.8777878-.5004101l1.68-2.8c1.0049939-1.6901509.6380089-3.8594682-.867-5.125l-1.912-1.589h15.24c2.7600532-.0033061 4.9966939-2.2399468 5-5v-40c-.0033061-2.76005315-2.2399468-4.99669388-5-5zm-50 2h50c1.6568542 0 3 1.34314575 3 3v3h-56v-3c0-1.65685425 1.34314575-3 3-3zm26 50.92v-12.92c0-.5522847-.4477153-1-1-1s-1 .4477153-1 1v12.92c-3.4409267-.4966526-5.9959255-3.4434178-6-6.92v-8c-.000854-1.9949939.8545402-3.8944133 2.349-5.216 1.1371568 1.402881 2.8466206 2.2177449 4.6525 2.2177449s3.5153432-.8148639 4.6525-2.2177449c.1.087.2.168.3.264.6253444.6297458 1.1264202 1.3716908 1.477 2.187v.011c.00363.0068818.007636.0135586.012.02.367252.8647218.5566811 1.7945226.557 2.734v8c-.0040745 3.4765822-2.5590733 6.4233474-6 6.92zm3-23.92c0 2.209139-1.790861 4-4 4s-4-1.790861-4-4 1.790861-4 4-4 4 1.790861 4 4zm21 19h-16.232c.1521372-.6558489.2299605-1.3267398.232-2v-4h2.914c.4678013.0002105.9207286.1643966 1.28.464l2.166 1.8c.2747372.22865.6505882.2933607.9859735.1697563.3353853-.1236045.579352-.4167456.64-.769.0606481-.3522545-.0712363-.7101063-.3459735-.9387563l-2.165-1.8c-.7194248-.5981105-1.6254209-.9256984-2.561-.926h-2.914v-2c.0006094-.8827331-.1284344-1.7607696-.383-2.606l3.957-1.7c1.470531-.6294331 2.4246807-2.0744233 2.426-3.674v-2.02c0-.5522847-.4477153-1-1-1s-1 .4477153-1 1v2.02c.0007705.8014816-.4770063 1.5260179-1.214 1.841l-3.965 1.7c-.3998664-.7077822-.8921923-1.3591724-1.464-1.937-.235-.229-.469-.435-.706-.625.3468746-.952884.4372258-1.9801978.262-2.979l.421-.251c2.2318483-1.3485598 3.0578172-4.1825027 1.9-6.519l-.34-.69c-.2530108-.4776691-.8398074-.6678232-1.3248914-.429337-.4850841.2384861-.6928531.8192795-.4691086 1.311337l.343.7c.7146317 1.3994762.2159188 3.1134185-1.138 3.911l-.065.039c-1.0557419-1.9067823-3.0634566-3.0900704-5.243-3.0900704s-4.1872581 1.1832881-5.243 3.0900704l-.062-.037c-1.3578366-.7994013-1.8568812-2.5188685-1.138-3.921l.34-.691c.2237445-.4920575.0159755-1.0728509-.4691086-1.311337-.485084-.2384862-1.0718806-.0483321-1.3248914.429337l-.336.682c-1.1619993 2.3391828-.3357077 5.1785817 1.9 6.529l.419.25c-.176236 1.0041721-.0837769 2.0370916.268 2.994-.8778443.7050155-1.6150302 1.5690802-2.173 2.547l-3.969-1.7c-.7357049-.316797-1.2114287-1.0419906-1.209-1.843v-2.02c0-.5522847-.4477153-1-1-1s-1 .4477153-1 1v2.02c-.0010816 1.6017569.9534649 3.0497089 2.426 3.68l3.974 1.7c-.2600685.842372-.3948437 1.7184108-.4 2.6v2h-2.914c-.9357032.0005825-1.8417132.3285292-2.561.927l-2.165 1.8c-.424707.3534622-.4824622.984293-.129 1.409s.984293.4824622 1.409.129l2.166-1.8c.359133-.2999638.8120742-.4645089 1.28-.465h2.914v4c.0020395.6732602.0798628 1.3441511.232 2h-16.232c-1.65685425 0-3-1.3431458-3-3v-35h56v35c0 1.6568542-1.3431458 3-3 3z"
          />
          <circle id="Oval" cx="5" cy="5" r="1" />
          <circle id="Oval" cx="9" cy="5" r="1" />
          <circle id="Oval" cx="13" cy="5" r="1" />
          <path
            id="Shape"
            d="m34 6h21c.5522847 0 1-.44771525 1-1s-.4477153-1-1-1h-21c-.5522847 0-1 .44771525-1 1s.4477153 1 1 1z"
          />
        </g>
      </g>
    </svg>
  );
}

export function QuickSearchToolbar(props) {
  return (
    <Box
      sx={{
        p: 0.5,
        pb: 0,
        justifyContent: "space-between",
        display: "flex",
        alignItems: "flex-start",
        flexWrap: "wrap",
      }}
    >
      <ThemeProvider theme={pageTheme}>
        <FormInputTextField
          color="secondary"
          variant="outlined"
          value={props.value}
          onChange={props.onChange}
          label="Search name…"
          InputProps={{
            endAdornment: (
              <IconButton
                title="Clear"
                aria-label="Clear"
                size="small"
                //style={{ visibility: props.value ? "visible" : "hidden" }}
                onClick={props.clearSearch}
              >
                {props.value ? <Clear fontSize="small" /> : <Search />}
              </IconButton>
            ),
          }}
          sx={{
            width: {
              xs: 1,
              sm: "auto",
            },
            m: (theme) => theme.spacing(1, 0.5, 1.5),
            "& .MuiSvgIcon-root": {
              mr: 0.5,
            },
            "& .MuiInput-underline:before": {
              borderBottom: 1,
              borderColor: "divider",
            },
          }}
        />
      </ThemeProvider>
    </Box>
  );
}

QuickSearchToolbar.propTypes = {
  clearSearch: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
};

export const TableBox = {
  width: "100%",
  backgroundColor: "#242933",
  border: " 1px solid gray",
  padding: "15px",
  boxShadow: "0px 4px 4px rgb(0 0 0 / 4%)",
  borderRadius: "14px",
  marginTop: "24px",
};

export const STATUS_TAG = {
  tested: {
    label: "Tested",
    className: "TagTest Success",
    chipColor: "success",
  },
  PartiallyTested: {
    label: "Partially Tested",
    className: "TagTest PartiallyTested",
    chipColor: "warning",
  },
  untested: {
    label: "Untested",
    className: "TagTest untested",
    chipColor: "error",
  },
  undefined: { label: "Undefined", className: "", chipColor: "error" },
};

export const THREAT_TYPE_TAG = {
  ZeroDay: {
    label: "Zero Day",
    color: "darkred",
    className: "ThreatType ZeroDay",
  },
  Critical: {
    label: "Critical",
    color: "#6a0000",
    className: "ThreatType Critical",
  },
  High: { label: "High", color: "#ff0000", className: "ThreatType High" },
  Midd: { label: "Mid", color: "#ff5830", className: "ThreatType Midd" },
  Mid: { label: "Mid", color: "#ff5830", className: "ThreatType Midd" },
  Low: { label: "Low", color: "#ffffa2", className: "ThreatType Low" },
  None: { label: "None", color: "#fff", className: "ThreatType None" },
  undefined: { label: "Undefined", color: "#fff", className: "" },
};

export const PACKAGE_TYPE_TAG = {
  Known: { label: "Known", color: "#8c30ff", className: "PackageType Known" },
  Challenger: {
    label: "Challenger",
    color: "#ff7e35",
    className: "PackageType Challenger",
  },
  Interactiva: {
    label: "Interactive",
    color: "#fff",
    className: "PackageType Interactiva",
  },
  Unknown: {
    label: "Uncategorized",
    color: "#ffab2d",
    className: "PackageType Unknown",
  },
  Zero: { label: "Zero", color: "#ff4747", className: "PackageType Zero" },
  undefined: {
    label: "Undefined",
    color: "#fff",
    className: "PackageType Undefined",
  },
  Uncategorized: {
    label: "Uncategorized",
    color: "#ffab2d",
    className: "PackageType Unknown",
  },
};

export function escapeRegExp(value) {
  return value.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
}
export const ReportModeSwitch = styled(Switch)(({ theme }) => ({
  width: 42,
  height: 26,
  padding: 0,
  "& .MuiSwitch-switchBase": {
    padding: 0,
    margin: 2,
    transitionDuration: "300ms",
    "&.Mui-checked": {
      transform: "translateX(16px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        backgroundColor: " #1e05ad",
        opacity: 1,
        border: 0,
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: 0.5,
      },
    },
    "&.Mui-focusVisible .MuiSwitch-thumb": {
      color: "#fff",
      border: "6px solid #fff",
    },
    "&.Mui-disabled .MuiSwitch-thumb": {
      color:
        theme.palette.mode === "light"
          ? theme.palette.grey[100]
          : theme.palette.grey[600],
    },
    "&.Mui-disabled + .MuiSwitch-track": {
      opacity: theme.palette.mode === "light" ? 0.7 : 0.3,
    },
  },
  "& .MuiSwitch-thumb": {
    boxSizing: "border-box",
    width: 22,
    height: 22,
  },
  "& .MuiSwitch-track": {
    borderRadius: 26 / 2,
    backgroundColor: "#790000a3",
    opacity: 1,
    transition: theme.transitions.create(["background-color"], {
      duration: 500,
    }),
  },
}));
export const SecondModeSwitch = styled(Switch)(({ theme }) => ({
  width: 42,
  height: 26,
  padding: 0,
  color: "#fff",
  "& .MuiSwitch-switchBase": {
    padding: 0,
    margin: 2,
    transitionDuration: "300ms",
    "&.Mui-checked": {
      transform: "translateX(16px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        backgroundColor: " #42006f",
        opacity: 1,
        border: 0,
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: 0.5,
      },
    },
    "&.Mui-focusVisible .MuiSwitch-thumb": {
      color: "#fff",
      border: "6px solid #fff",
    },
    "&.Mui-disabled .MuiSwitch-thumb": {
      color:
        theme.palette.mode === "light"
          ? theme.palette.grey[100]
          : theme.palette.grey[600],
    },
    "&.Mui-disabled + .MuiSwitch-track": {
      opacity: theme.palette.mode === "light" ? 1 : 1,
      color: "#fff",
    },
  },
  "& .MuiSwitch-thumb": {
    boxSizing: "border-box",
    width: 22,
    height: 22,
  },
  "& .MuiSwitch-track": {
    borderRadius: 26 / 2,
    backgroundColor: "transparent",
    opacity: 1,
    transition: theme.transitions.create(["background-color"], {
      duration: 500,
    }),
  },
}));
export const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 22,
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundImage: "linear-gradient( 95deg,#c59d48 0%,#090f1a 100%)",
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundColor: "#c59d48",
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    height: 3,
    border: 0,
    backgroundColor: "#1e1c3a",
    borderRadius: 1,
  },
}));

const ColorlibStepIconRoot = styled(Box)(({ theme, ownerState }) => ({
  backgroundColor: "#090f1a",
  border: "1.37962px solid #1e1c3a",
  zIndex: 1,
  color: "#fff",
  width: 50,
  height: 50,
  display: "flex",
  borderRadius: "13.74px",
  justifyContent: "center",
  alignItems: "center",
  ...(ownerState.active && {
    backgroundColor: "#544628",
    boxShadow: "0px 13.7962px 27.5924px rgba(0, 0, 0, 0.05)",
  }),
  ...(ownerState.completed && {
    backgroundColor: "#c59d48",
    boxShadow: "0px 13.7962px 27.5924px rgba(0, 0, 0, 0.9)",
  }),
}));

export function ColorlibStepIcon(props) {
  const { active, completed, className } = props;

  const icons = {
    1: <img src={DateIcon} alt="" />,
    2: <img src={PackageIcon} alt="" />,
    3: <TextIncrease />,
    4: <img src={ArrowBackIcon} alt="" />,
    5: <img src={AgentsIcon} alt="" />,
    6: <img src={AccountIcon} alt="" />,
    7: <img src={LaunchIcon} alt="" />,
  };

  return (
    <ColorlibStepIconRoot
      ownerState={{ completed, active }}
      className={className}
    >
      {icons[String(props.icon)]}
    </ColorlibStepIconRoot>
  );
}

ColorlibStepIcon.propTypes = {
  /**
   * Whether this step is active.
   * @default false
   */
  active: PropTypes.bool,
  className: PropTypes.string,
  /**
   * Mark the step as completed. Is passed to child components.
   * @default false
   */
  completed: PropTypes.bool,
  /**
   * The label displayed in the step icon.
   */
  icon: PropTypes.node,
};
export function ColorlibStepIOC(props) {
  const { active, completed, className } = props;

  const icons = {
    1: <PlayCircleFilled />,
    2: <Upcoming />,
    3: <LaptopChromebook />,
    4: <DriveFileRenameOutline />,
    5: <RocketLaunch />,
  };
  return (
    <ColorlibStepIconRoot
      ownerState={{ completed, active }}
      className={className}
    >
      {icons[String(props.icon)]}
    </ColorlibStepIconRoot>
  );
}

ColorlibStepIcon.propTypes = {
  /**
   * Whether this step is active.
   * @default false
   */
  active: PropTypes.bool,
  className: PropTypes.string,
  /**
   * Mark the step as completed. Is passed to child components.
   * @default false
   */
  completed: PropTypes.bool,
  /**
   * The label displayed in the step icon.
   */
  icon: PropTypes.node,
};

export function ColorlibStepReport(props) {
  const { active, completed, className } = props;

  const icons = {
    1: <DescriptionTwoTone />,
    2: <SecurityTwoTone />,
    3: <LibraryAddCheckTwoTone />,
    4: <DocumentScanner />,
  };
  return (
    <ColorlibStepIconRoot
      ownerState={{ completed, active }}
      className={className}
    >
      {icons[String(props.icon)]}
    </ColorlibStepIconRoot>
  );
}

ColorlibStepReport.propTypes = {
  /**
   * Whether this step is active.
   * @default false
   */
  active: PropTypes.bool,
  className: PropTypes.string,
  /**
   * Mark the step as completed. Is passed to child components.
   * @default false
   */
  completed: PropTypes.bool,
  /**
   * The label displayed in the step icon.
   */
  icon: PropTypes.node,
};

export const CostumTabs = styled(Tabs)({
  backgroundColor: "#66638f63",
  paddingLeft: "7px",
  borderRadius: "15px 15px 0px 0px",
  "& .MuiTabs-indicator": {
    backgroundColor: "#c59d48",
  },
});

export const CostumTab = styled(Tab)(({ theme }) => ({
  textTransform: "none",
  minWidth: 0,
  [theme.breakpoints.up("sm")]: {
    minWidth: 0,
  },
  fontWeight: theme.typography.fontWeightRegular,
  marginRight: theme.spacing(1),
  color: "#cbb3f7",
  backgroundColor: "#15132b",
  borderRadius: "16px 16px 0px 0px",
  fontFamily: [
    "-apple-system",
    "BlinkMacSystemFont",
    '"Segoe UI"',
    "Roboto",
    '"Helvetica Neue"',
    "Arial",
    "sans-serif",
    '"Apple Color Emoji"',
    '"Segoe UI Emoji"',
    '"Segoe UI Symbol"',
  ].join(","),
  "&:hover": {
    color: "#cbb3f750",
    opacity: 1,
  },
  "&.Mui-selected": {
    color: "#fff",
    fontWeight: theme.typography.fontWeightMedium,
    backgroundColor: "#0a0818",
  },
  "&.Mui-focusVisible": {
    backgroundColor: "#d1eaff",
  },
}));
